import createIcon from '../../createIcon';

/**
 * @component @name AutoGraph
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuMDYgMTAuNjlMMTIgOS43NUwxNC4wNiA4LjgxTDE1IDYuNzVMMTUuOTQgOC44MUwxOCA5Ljc1TDE1Ljk0IDEwLjY5TDE1IDEyLjc1TDE0LjA2IDEwLjY5Wk00IDE0Ljc1TDQuOTQgMTIuNjlMNyAxMS43NUw0Ljk0IDEwLjgxTDQgOC43NUwzLjA2IDEwLjgxTDEgMTEuNzVMMy4wNiAxMi42OUw0IDE0Ljc1Wk04LjUgOS43NUw5LjU5IDcuMzRMMTIgNi4yNUw5LjU5IDUuMTZMOC41IDIuNzVMNy40MSA1LjE2TDUgNi4yNUw3LjQxIDcuMzRMOC41IDkuNzVaTTQuNSAyMS4yNUwxMC41IDE1LjI0TDE0LjUgMTkuMjRMMjMgOS42OEwyMS41OSA4LjI3TDE0LjUgMTYuMjRMMTAuNSAxMi4yNEwzIDE5Ljc1TDQuNSAyMS4yNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoGraph = createIcon('AutoGraph', [
  [
    'path',
    {
      d: 'M14.06 10.69L12 9.75L14.06 8.81L15 6.75L15.94 8.81L18 9.75L15.94 10.69L15 12.75L14.06 10.69ZM4 14.75L4.94 12.69L7 11.75L4.94 10.81L4 8.75L3.06 10.81L1 11.75L3.06 12.69L4 14.75ZM8.5 9.75L9.59 7.34L12 6.25L9.59 5.16L8.5 2.75L7.41 5.16L5 6.25L7.41 7.34L8.5 9.75ZM4.5 21.25L10.5 15.24L14.5 19.24L23 9.68L21.59 8.27L14.5 16.24L10.5 12.24L3 19.75L4.5 21.25Z',
      key: '1u6n5d',
    },
  ],
]);

export default AutoGraph;
